import styled from 'styled-components';
import {dFlex, dFlexCenter, alignCenter} from '../../globalVariables/GlobalFlex';
import {getSpacing, getPrimitive, tokens} from '@tickchak/react-share/app';

const LIKE_COLOR = getPrimitive('greens.green400');
const DISLIKE_COLOR = getPrimitive('reds.red400');
const DEFAULT_BG = getPrimitive('blackAlphas.black05');
const HOVER_BG = getPrimitive('blackAlphas.black10');

export const buttonsContainer = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceSm')};

    .feedback-btn {
        min-width: auto;
        width: auto;
        max-width: none;
        border-radius: 100px;
        padding: 0 ${tokens.spacing.spaceLg};
        background: ${DEFAULT_BG};
        transition: all 200ms;

        svg {
            width: 20px;
            height: 20px;
        }

        &:hover {
            background: ${HOVER_BG};
        }

        &.like.active {
            background: ${LIKE_COLOR};
            &:hover {
                background: ${LIKE_COLOR};
            }
        }

        &.dislike.active {
            background: ${DISLIKE_COLOR};
            &:hover {
                background: ${DISLIKE_COLOR};
            }
        }
    }
`;

export const rotatedIcon = styled.span`
    ${dFlexCenter}
    transform: scaleY(-1);
`;
